import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./Header.module.scss";
import imgLogo from "../../../assets/images/DPIE.png";
import { Button } from "@onegovbugs/onegov-react-components";
import userManager from "../../../userManager";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { useTimer } from "../timer/Timer";
import IdleTimer from "react-idle-timer";
import { saveApplication } from "../../../redux/actions";
import { getStepNumberWithFloraFaunaUrl, getStepNumberIndWithImportExportUrl, getStepNumberOrgWithImportExportUrl } from "../../../utils/NavigationHelper";
import { IMPORTEXPORT_FORM, FLORAFAUNA_FORM } from "../../../constants";
import LogoutConfirmation from "./LogoutConfirmation";

const Header = (props) => {
  const oidc = useSelector((state) => state.oidc);
  const [logoutMode, setLogoutMode] = useState(false);
  const application = useSelector((state) => state.application);
  const { addTimer, removeTimer, Count } = useTimer();
  const form = useSelector((state) => state.form);

  const dispatch = useDispatch();

  return (
    <div>
      {props.match.path !== "/" &&
      props.match.path !== "/flora-fauna" &&
      props.match.path !== "/import-export" &&
      props.match.path !== "/import-export/introduction" &&
      application.applicationId
        ? oidc.user && (
            <div className={`row`}>
              <div className={`col-12`}>
                {
                  <IdleTimer
                    timeout={1000 * 30 * 60}
                    onActive={(e) => {
                      removeTimer("timerformidle");
                    }}
                    onIdle={(e) => {
                      addTimer("timerformidle", 60);
                    }}
                  />
                }
                <Count on={"timerformidle"}>
                  {(props) => {
                    const { minutes, seconds, completed } = props.timeDelta;

                    if (completed && logoutMode != true) {
                      setLogoutMode(true);
                      if (form.form === IMPORTEXPORT_FORM) {
                        dispatch(
                          saveApplication(
                            getStepNumberIndWithImportExportUrl(
                              window.location.pathname
                            ),
                            () => {
                              //userManager.signoutRedirect();
                            }
                          )
                        );
                      } else {
                        dispatch(
                          saveApplication(
                            getStepNumberWithFloraFaunaUrl(
                              window.location.pathname
                            ),
                            () => {
                              //userManager.signoutRedirect();
                            }
                          )
                        );
                      }

                      return null;
                    }

                    return (
                      <div className={styles.headline}>
                        <div className={styles.siteContainer}>
                          You will be logged out in{" "}
                          <strong>
                            {minutes} minutes {seconds} seconds{" "}
                          </strong>
                        </div>
                      </div>
                    );
                  }}
                </Count>
              </div>
            </div>
          )
        : null}
      <div className={styles.logoContainer}>
        <div className={`row`}>
          <div className={`col-8`}>
            <img
              src={imgLogo}
              alt={
                props.type === undefined
                  ? "NSW Government FloraFauna Logo"
                  : "NSW Government Import/Export Logo"
              }
              className={styles.logo}
            />
            <div className={styles.slogan}>
              {/* <h1>{props.type === undefined ? `Flora and Fauna` : `Import/Export`}</h1> */}
              <h1></h1>
            </div>
          </div>
          <div className={`col-4 ${styles.logoutCont}`}>
            {props.match.path !== "/" &&
            (props.match.path !== "/flora-fauna" ||
              props.match.path !== "/import-export" ||
              props.match.path !== "/import-export/introduction") ? (
              oidc.user ? (
                <Button secondary onClick={() => userManager.signoutRedirect()}>
                  Logout
                </Button>
              ) : (
                <Button secondary onClick={() => userManager.signinRedirect()}>
                  Login
                </Button>
              )
            ) : null}
          </div>
        </div>
      
        {logoutMode === true && (
          <LogoutConfirmation
            onLogoutClick={() => {
              userManager.signoutRedirect();
            }}
            onClickClose={() => {
              setLogoutMode(false);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default withRouter((props) => <Header {...props} />);
